import { useEffect, useState, Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";

import Header from "./Header";
import Znamke from "./Znamke";
import Obvestila from "./Obvestila";
import Statistics from "./Statistics";

import axios from "../../utils/axios";

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [adsList, setAds] = useState<Array<Object>>([]);
  const [alertsList, setAlerts] = useState<Array<Object>>([]);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    setIsLoading(true);
    axios
      .get("/ads?listId=1")
      .then((response: any) => {
        setAds(response.data.ads);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));

    axios
      .get("/alerts/messages?pageSize=20")
      .then((response: any) => {
        setAlerts(response.data.alertMessages.rows);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [isAuthenticated]);

  return (
    <Fragment>
      <Helmet title="Prva stran" />
      <Container fluid className="p-0">
        <Header />
        <Statistics ads={adsList} />
        <Row>
          <Col lg="6" className="d-flex">
            <Obvestila alerts={alertsList} />
          </Col>
          <Col lg="4" className="d-flex">
            <Znamke ads={adsList} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Dashboard;
